import { type AlgoliaHits } from 'shared/utils/algolia/types'

const STORAGE_KEY = 'algolia-dynamic-re-ranking-status'

export function storeDynamicReRankingStatusInSessionStorage(
  searchResults: AlgoliaHits[]
): void {
  if (typeof sessionStorage !== 'undefined') {
    try {
      // if any product has promotedByReRanking true
      const hasRerankedProduct = searchResults.some(
        product => product.promotedByReRanking === true
      )
      if (hasRerankedProduct) {
        sessionStorage.setItem(STORAGE_KEY, 'true')
      } else {
        sessionStorage.removeItem(STORAGE_KEY)
      }
    } catch (error) {
      throw new Error(
        `Failed to store search results in session storage: ${error}`
      )
    }
  }
}
